import { acss } from '@adornis/chemistry/directives/acss.js';
import { LogistikPageLanding } from '@chancenlogistik/client/pages/logistik-page-landing.js';
import { LogistikRoutes } from '@chancenwerk/logistik/client/routes.js';
import { html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';

@customElement('hefte-page-landing')
export class HeftePageLanding extends LogistikPageLanding {
  override render() {
    return html`
      <logistik-component-base-page-layout>
        <cr-flex space="lg" center w100>
          <cr-h2> Herzlich Willkommen bei den CHANCENheften! </cr-h2>
          <cr-grid
            horizontal
            space="md"
            auto-fill-columns="350px"
            ${acss({
              'cr-card': { cursor: 'pointer', background: this.colors.accent, color: this.colors.light, width: '100%' },
              'cr-icon': { fontSize: this.spacing.xl },
            })}
          >
            ${this._learningMaterialCount.value
              ? this._card(LogistikRoutes.learningMaterials, 'library_books', 'CHANCENhefte')
              : nothing}
            ${this._logistikProductSetCount.value
              ? this._card(LogistikRoutes.logistikProductSets, 'package_2', 'CHANCENsets')
              : nothing}
          </cr-grid>
        </cr-flex>
      </logistik-component-base-page-layout>
    `;
  }
}
